import { requestServise } from "@/shared";
import $api from "@/shared/http";
import { RootState } from "@/app/appStore";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { CartProductType, ItemToCart } from "../../model/types";

export const addProductionItemsCart = requestServise.post<{
  items: ItemToCart[];
}>("cart/addProductionItemsCart", "/basket/production/items");

export const fetchProductionCart = createAsyncThunk<
  { items: CartProductType[]; totalCount: number },
  void,
  { state: RootState; rejectValue: string }
>(
  "cart/fetchProductionCart",
  async (_, { getState, rejectWithValue, signal }) => {
    const state = getState().cart;

    const body = {
      order: state.productionOrder,
      pagination: {
        pageSize: state.productionPageSize,
        pageNumber: state.productionPageNumber,
      },

      filters: [{ fields: state.selectedProductionFilters, type: "eq" }],
    };
    try {
      const response = await $api.post(
        "/basket/production",
        JSON.stringify(body),
        { signal },
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error("Server error");
      }
    } catch (error) {
      if (signal.aborted || error?.code === "ERR_CANCELED") {
        return rejectWithValue("canceled");
      }
      return rejectWithValue(error.message);
    }
  },
);

export const deleteProductionCart = requestServise.delete(
  "cart/deleteProductionCart",
  "/basket/production",
);
